const AuditType = {

    //Document
    DOCUMENT_DELETE: 1,
    DOCUMENT_INSERT: 2,
    DOCUMENT_UPDATE: 4,
    DOCUMENT_UPDATE_ATTACHMENT: 22,
    DOCUMENT_DELETE_PERMANENTLY: 6,
    DOCUMENT_RESTORE: 7,
    DOCUMENT_ARCHIVE: 27,
    DOCUMENT_DOWNLOAD: 36,
    DOCUMENT_DISPLAY: 40,
    DOCUMENT_PRINT: 46,
    DOCUMENT_AUTO_UPDATE: 48,
    DOCUMENT_CONTENT_TYPE_CHANGE: 52,
    DOCUMENT_SIGN: 69,
    DOCUMENT_SEND_BY_EMAIL: 47,
    COMMENT_CREATE: 57,
    COMMENT_CREATE_EXTERNAL: 74,
    COMMENT_UPDATE: 58,
    COMMENT_DELETE: 59,
    DOCUMENT_ATTACHMENT_INSERT: 63,
    DOCUMENT_ATTACHMENT_UPDATE: 64,
    DOCUMENT_ATTACHMENT_DELETE: 65,
    DOCUMENT_ATTACHMENT_DISPLAY: 66,
    DOCUMENT_ATTACHMENT_DOWNLOAD: 67,
    DOCUMENT_DISPLAY_EXTERNAL: 68,
    DOCUMENT_SIGN_EXTERNAL: 70,
    DOCUMENT_DOWNLOAD_EXTERNAL: 71,
    DOCUMENT_VALIDATE_EXTERNAL: 72,
    DOCUMENT_REJECT_EXTERNAL: 73,
    DOCUMENT_FLOW_NOTIFICATION_EXTERNAL: 75,
    DOCUMENT_LINKED: 77,
    DOCUMENT_UNLINKED: 78,

    //Flow
    FLOW_VALIDATE_ACTION: 23,
    FLOW_REFUSE_ACTION: 24,
    FLOW_DISTRIBUTE_ACTION: 25,
    FLOW_END_DISTRIBUTION_ACTION: 26,
    FLOW_END_SINGLE_DISTRIBUTION_ACTION: 79,

    //Search
    USER_ADVANCED_SEARCH: 37,
    USER_NATURAL_SEARCH: 38,
    USER_BASKET_SEARCH: 39,
    USER_NOTIFICATION_SEARCH: 42,

    //User
    USER_LOGIN: 29,
    USER_LOGOUT: 30,
    USER_BLOCKED: 31,
    USER_BLOCKED_BY_EXPIRATION_PASSWORD: 32,
    USER_NAME_OR_PASSWORD_INCORRECT: 33,
    USER_BLOCKED_BY_INACTIVITY: 34,
    USER_BLOCKED_BY_ATTEMPTS: 35,
    USER_PASSWORD_UPDATE: 41,
    USER_RECOVER_PASSWORD: 49,
    USER_RECOVER_DEVICE: 62,

    //Administration
    ADMINISTRATION_DELETE: 43,
    ADMINISTRATION_UPDATE: 44,
    ADMINISTRATION_CREATE: 45,

    //Delegation
    DELEGATION_SCHEDULED_START: 53,
    DELEGATION_SCHEDULED_END: 54,
    DELEGATION_MANUAL_START: 55,
    DELEGATION_MANUAL_END: 56,

    COLOR_INSERT: '#0073b7',
    COLOR_PRINT: '#0b5cb3',
    COLOR_UPDATE: '#e08e0b',
    COLOR_DELETE: '#d9534f',
    COLOR_DRAG_AND_DROP: '#d81b60',
    COLOR_DISPLAY: '#00c0ef',
    COLOR_DOWNLOAD: '#21d2b9',
    COLOR_ARCHIVE: '#ffeb3b',
    COLOR_VALIDATE: '#69aa46',
    COLOR_REFUSE: '#dd5a43',
    COLOR_DISTRIBUTE: '#69aa46',
};
export default AuditType;
